import React from "react";
import { RemoteGeniusBenefitsCarousel, RemoteGeniusSignInBanner } from "./index.js";
import useGlobalContext from "../../hooks/useGlobalContext.js";
const GeniusLoyalty = () => {
    const { auth } = useGlobalContext();
    if (auth.isAuthenticatedOnWeb) {
        return React.createElement(RemoteGeniusBenefitsCarousel, null);
    }
    else {
        return React.createElement(RemoteGeniusSignInBanner, null);
    }
};
export default GeniusLoyalty;
